import OrderSummary from "../Shared/OrderSummary";
import OrderConfirmationMessage from "../Shared/OrderConfirmationMessage";
import OrderTotal from "../Shared/OrderTotal";
import AcknowledgeRecurringDonationMessage from "../Shared/AcknowledgeRecurringDonationMessage";

const TourOrderSummary = ({ products }) => (
  <OrderSummary visible={true}>
    <OrderConfirmationMessage messagePhraseKey="tours.submission.order_confirmation" />
    <OrderTotal
      className="order-summary__total"
      products={products}
      disabled={false}
      totalDefault={39}
    />
    <AcknowledgeRecurringDonationMessage />
  </OrderSummary>
);

export default TourOrderSummary;
